/* eslint-disable camelcase */
import axios from 'axios';
import {
  GROUP_OF_PRODUCT_PRICING_ENDPOINT,
  MASTER_SALE_FORMAT_ENDPOINT,
  MENU_ENDPOINT,
  NEW_PRODUCTS_ENDPOINT,
  PERIOD_LIST_SIZE,
  POINT_OF_SALE_SETTINGS_ENDPOINT,
  PREDICTION_PERIOD_ENDPOINT,
  PRODUCT_ENDPOINT,
  PRODUCT_SALE_FORMAT_ENDPOINT,
  SALE_RATE_ENDPOINT,
  SERVICE_ENDPOINT
} from '@dynameat/constants';

export const saleRateListRequest = (point_of_sale__guid) => axios.get(SALE_RATE_ENDPOINT(), {
  params: { point_of_sale__guid, page_size: 0 }
});

export const masterSaleFormatListRequest = (point_of_sale__guid) => axios.get(MASTER_SALE_FORMAT_ENDPOINT(), {
  params: { point_of_sale__guid, page_size: 0 }
});

export const productRequest = (product__guid) => axios.get(PRODUCT_ENDPOINT(product__guid));

export const servicesRequest = (point_of_sale__guid) => axios.get(SERVICE_ENDPOINT(), {
  params: { point_of_sale__guid, page_size: 0 }
});

export const predictionPeriodListRequest = (point_of_sale__guid) => axios.get(PREDICTION_PERIOD_ENDPOINT(), {
  params: { point_of_sale__guid, page_size: PERIOD_LIST_SIZE, page: 1 }
});

export const groupOfProductPricingListRequest = (point_of_sale__guid) => axios.get(GROUP_OF_PRODUCT_PRICING_ENDPOINT(), {
  params: { point_of_sale__guid, page_size: 0 }
});

export const predictionPeriodRequest = (prediction_period_guid) => axios.get(PREDICTION_PERIOD_ENDPOINT(prediction_period_guid));

export const pointOfSaleSettingsRequest = (point_of_sale__guid) => axios.get(POINT_OF_SALE_SETTINGS_ENDPOINT(point_of_sale__guid));

export const newProductsRequest = (point_of_sale__guid) => axios.get(NEW_PRODUCTS_ENDPOINT(), {
  params: { point_of_sale__guid }
});

// Products
// https://github.com/axios/axios#cancellation
export const productListRequest = async (point_of_sale__guid, cancelToken, customParams = {}) => {
  try {
    return await axios.get(PRODUCT_ENDPOINT(), {
      params: { point_of_sale__guid, page_size: 200, ...customParams }, cancelToken
    });
  } catch (error) {
    if (!axios.isCancel(error)) throw error;
  }
  return undefined;
};

export const updateMasterProductRequest = (productToUpdate) => axios.patch(PRODUCT_ENDPOINT(productToUpdate.get('guid')),
  productToUpdate, { headers: { 'content-type': 'multipart/form-data' } });

export const updateMasterProductSaleFormats = (productToUpdate) => axios.post(PRODUCT_SALE_FORMAT_ENDPOINT(),
  productToUpdate.serializeSaleFormats());

// Menu
export const menuListRequest = (point_of_sale__guid) => axios.get(MENU_ENDPOINT(),
  { params: { point_of_sale__guid, page_size: 0 } });
// Menu
export const createMenuRequest = (menu) => axios.post(MENU_ENDPOINT(), menu);
export const editMenuRequest = (menu__guid, menu) => axios.put(MENU_ENDPOINT(menu__guid), menu);
export const deleteMenuRequest = (menu__guid) => axios.delete(MENU_ENDPOINT(menu__guid));

export const publishMenuRequest = (menu__guid) => axios.get(`${MENU_ENDPOINT(menu__guid)}/publish`,
  { validateStatus: ((status) => status >= 200 && status <= 300 && status !== 202) });
